import { Location } from "@/interfaces/location";
import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./NavigationDrawer.template.vue";
@Component({
  mixins: [Template]
})
export class NavigationDrawerComponent extends Vue {
  public search = "";

  public selectedFilter = "";

  @Prop({ required: true })
  public filters!: Location[];

  public filterBy(filter: Location) {
    this.selectedFilter = filter.name;
    this.$emit("filterSelected", filter);
  }

  public isSelected(filterName: string) {
    return this.selectedFilter === filterName;
  }
}
